const spinnerContainerStyle = {
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: "#FFFFFF",
  marginTop: "10px",
};

const spinnerStyle = {
  width: "25px",
  height: "25px",
  color: "#7366FF",
  animation: "spin 2s linear infinite",
};

const loadingContainerStyle = {
  width: "100vw",
  height: "100vh",
  background: "rgba(0, 0, 0, 0.6)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "fixed",
  top: "0",
  left: "0",
  zIndex: "9999",
};

const loaderBoxStyle = {
  width: "150px",
  height: "100px",
  background: "#FFFFFF",
  overflow: "hidden",
  borderRadius: "10px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  padding: "0 15px",
};

const Loader = () => {
  return (
    <div style={loadingContainerStyle}>
      <div style={loaderBoxStyle}>
        <div style={spinnerContainerStyle}>
          <div className="h-10 w-10 animate-spin rounded-full border-4 border-gray-300 border-t-blue-500"></div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
